import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { MutationConfig } from '@/src/lib/react-query/react-query';

import {
  inboxRequiredAction,
  inboxIsAutomationEnabled,
  inboxPrefillSettingsEnabled,
} from '../types';

type saveInboxSettingParams = {
  selectedId: number;
  params: {
    requiredAction: inboxRequiredAction;
    isAutomationEnabled: inboxIsAutomationEnabled;
    isLineSuggestionsEnabled: inboxPrefillSettingsEnabled;
  };
};

interface saveInboxSettingOptions extends saveInboxSettingParams {
  config?: MutationConfig<typeof saveInboxSetting>;
}

const saveInboxSetting = async ({ selectedId, params }: saveInboxSettingParams) => {
  return axios.put(`/api/project/update/${selectedId}`, params);
};

export const useSaveInboxSetting = ({ selectedId, params }: saveInboxSettingOptions) => {
  return useMutation({
    mutationFn: saveInboxSetting,
  });
};
